"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var parse_1 = require("../helpers/parse");
var PngExport = /** @class */ (function () {
    function PngExport(config, book) {
        this.config = config;
        this.book = book;
        this.fontLoaded = false;
        this.options = this.config.configJson.preview.meta.export;
        if (!this.options) {
            return;
        }
        this.canvas = document.createElement('canvas');
        this.canvas.setAttribute('height', this.options.height);
        this.canvas.setAttribute('width', this.options.width);
        this.ctx = this.canvas.getContext('2d');
    }
    PngExport.prototype.getPng = function () {
        return __awaiter(this, void 0, void 0, function () {
            var font, _loop_1, this_1, _i, _a, layer;
            var _this = this;
            return __generator(this, function (_b) {
                this.ctx.resetTransform();
                this.ctx.fillStyle = '#fff';
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
                font = new FontFace('SpecialForcesRegular', "url(" + this.config.params.assets + "/fonts/SpecialForcesRegular/webFonts/font.woff2)");
                font.load().then(function () {
                    document.fonts.add(font);
                    _this.fontLoaded = true;
                    _this.checkRessourcesLoaded();
                });
                this.requests = [];
                _loop_1 = function (layer) {
                    var image = new Image();
                    image.onload = function () { _this.onImageLoaded(image); };
                    image.src = layer;
                    this_1.requests.push({
                        image: image,
                        loaded: false
                    });
                };
                this_1 = this;
                for (_i = 0, _a = this.getLayers(); _i < _a.length; _i++) {
                    layer = _a[_i];
                    _loop_1(layer);
                }
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.resolve = resolve;
                    })];
            });
        });
    };
    PngExport.prototype.onImageLoaded = function (image) {
        var request = this.requests.find(function (r) { return r.image === image; });
        request.loaded = true;
        this.checkRessourcesLoaded();
    };
    PngExport.prototype.checkRessourcesLoaded = function () {
        var loaded = true;
        if (this.fontLoaded !== true) {
            loaded = false;
        }
        for (var _i = 0, _a = this.requests; _i < _a.length; _i++) {
            var request = _a[_i];
            if (request.loaded !== true) {
                loaded = false;
            }
        }
        if (loaded) {
            this.drawCanvas();
        }
    };
    PngExport.prototype.drawCanvas = function () {
        for (var _i = 0, _a = this.requests; _i < _a.length; _i++) {
            var layer = _a[_i];
            this.ctx.drawImage(layer.image, 0, 0);
        }
        var text = this.book.figur_1.name.toUpperCase();
        this.ctx.setTransform(1, -.122, 0, 1, 0, 0);
        this.ctx.font = '160px SpecialForcesRegular';
        this.ctx.textAlign = 'center';
        this.ctx.fillStyle = '#fff';
        this.ctx.strokeStyle = '#000';
        this.ctx.lineJoin = 'round';
        this.ctx.lineWidth = 20;
        this.ctx.strokeText(text, 938, 867);
        this.ctx.fillText(text, 938, 867);
        this.resolve(this.canvas.toDataURL('img/png'));
    };
    PngExport.prototype.getLayers = function () {
        var _this = this;
        var urls = [];
        var page = this.config.configJson.preview.pages.find(function (p) { return p.id === _this.options.page; });
        if (!page) {
            return [];
        }
        var layers = JSON.parse(JSON.stringify(page.layers));
        var layersConfig = layers.filter(function (l) { return l.type === 'image'; });
        for (var _i = 0, layersConfig_1 = layersConfig; _i < layersConfig_1.length; _i++) {
            var layerConfig = layersConfig_1[_i];
            var layerOptions = layerConfig.options;
            for (var _a = 0, layerOptions_1 = layerOptions; _a < layerOptions_1.length; _a++) {
                var layerOption = layerOptions_1[_a];
                layerOption.$condition = layerOption.condition || 'true';
                parse_1.evaluateOptions(layerOption, Object.assign({}, this.book));
            }
            layerOptions = layerOptions.filter(function (l) { return !!l.condition; });
            if (layerOptions.length) {
                var url = this.config.params.assets + "/" + this.options.directory + "/" + layerOptions[0].value;
                urls.push(url);
            }
        }
        return urls;
    };
    return PngExport;
}());
exports.PngExport = PngExport;
exports.default = angular.module('pb.pngExport', [])
    .service('pngExport', PngExport);
